import '@/styles/legal-pages.css';

type LegalSection = {
  title: string;
  paragraphs: string[];
};

const LegalPageLayout = ({ title, sections }: { title: string; sections: LegalSection[] }) => {
  return (
    <div className="legal-pages-shell">
      <div className="legal-pages-container">
        <div className="legal-pages-content">
          <h1 className="legal-pages-title">{title}</h1>
          {sections.map((section) => (
            <section key={section.title} className="legal-pages-section">
              <h2>{section.title}</h2>
              {section.paragraphs.map((paragraph) => (
                <p key={paragraph.slice(0, 32)}>
                  {paragraph}
                </p>
              ))}
            </section>
          ))}
        </div>
      </div>
    </div>
  );
};

export const MentionsLegalesPage = () => (
  <LegalPageLayout
    title="Mentions Légales"
    sections={[
      {
        title: '1. Éditeur du site',
        paragraphs: [
          "Le site https://www.hemo-j.com est édité par E-PRIME DELIVERY, SARL au capital de 100 EUR, dénomination Hémo-J, siège social 60 Rue François 1er 75008 Paris, immatriculation 999 040 363 R.C.S. Paris, TVA intracommunautaire FR66 999 040 363.",
          'Directeur de la publication : LARABI Yacine El Habib.',
        ],
      },
      {
        title: '2. Hébergement',
        paragraphs: ['Le site est hébergé par légal place - LWS, 10 rue de Ponthievre 75008 Paris, France.'],
      },
      {
        title: '3. Contact',
        paragraphs: ['Pour toute question : contact@hemo-j.com'],
      },
      {
        title: '4. Propriété intellectuelle',
        paragraphs: [
          "L'ensemble du site (structure, textes, logos, images) est protégé par le droit d'auteur et la propriété intellectuelle.",
          "Toute reproduction, représentation, modification ou adaptation totale ou partielle est interdite sans autorisation écrite préalable de Hémo-J.",
        ],
      },
      {
        title: '5. Règlement des litiges (UE)',
        paragraphs: [
          "Conformément au Règlement (UE) n°524/2013, la plateforme de Règlement en Ligne des Litiges est disponible sur : https://ec.europa.eu/consumers/odr",
        ],
      },
    ]}
  />
);

export const CgvPage = () => (
  <LegalPageLayout
    title="Conditions Générales de Vente (CGV)"
    sections={[
      {
        title: 'Article 1 - Société',
        paragraphs: [
          "Les présentes CGV régissent les ventes réalisées sur https://www.hemo-j.com. Hémo-J est édité par E-PRIME DELIVERY, SARL, siège social 60 Rue François 1er 75008 Paris, immatriculée 999 040 363 R.C.S. Paris.",
          'TVA intracommunautaire : FR66 999 040 363. Contact : contact@hemo-j.com.',
        ],
      },
      {
        title: 'Article 2 à 6 - Définitions, champ, commande, obligations',
        paragraphs: [
          "Toute commande implique l'acceptation sans réserve des CGV. Le client sélectionne les produits, valide le panier, accepte les CGV et procède au paiement.",
          "Le client s'engage à fournir des informations exactes et à utiliser le site de manière non frauduleuse.",
        ],
      },
      {
        title: 'Article 7 à 13 - Prix, disponibilité, rétractation, paiement, livraison',
        paragraphs: [
          "Les prix sont indiqués en EUR TTC. Les offres sont valables dans la limite des stocks disponibles.",
          "Le droit de rétractation est de 14 jours sauf exceptions légales (notamment produits descellés pour raisons d'hygiène/santé).",
          "Réclamations (colis endommagé/erreur) à signaler à contact@hemo-j.com avec photos, numéro de commande et description.",
        ],
      },
      {
        title: 'Article 14 à 19 - Garanties, responsabilité, données, litiges',
        paragraphs: [
          "Le client bénéficie des garanties légales applicables. Les produits sont des compléments alimentaires et ne constituent pas des médicaments.",
          "Les données sont traitées conformément au RGPD. Droit applicable : droit français.",
          "En cas de litige, une résolution amiable est recherchée via contact@hemo-j.com.",
        ],
      },
    ]}
  />
);

export const CgvPartenairesPage = () => (
  <LegalPageLayout
    title="CGV Partenaires - Marketplace"
    sections={[
      {
        title: 'Article 1 - Champ d’application',
        paragraphs: [
          "Ces conditions encadrent l'utilisation de la Plateforme Ventes Partenaires Hémo-J et les relations entre Hémo-J (opérateur de plateforme) et les clients.",
          "Le client conclut un contrat directement avec le vendeur partenaire pour les offres concernées.",
        ],
      },
      {
        title: "Article 2 - Rôle d'Hémo-J",
        paragraphs: [
          "Hémo-J agit en qualité d'intermédiaire technique. Sauf mention contraire, Hémo-J n'est pas le vendeur des offres partenaires.",
        ],
      },
      {
        title: 'Article 3 à 9 - Offres, commandes, paiement, livraison, rétractation, SAV',
        paragraphs: [
          "Les fiches descriptives indiquent l'identité du vendeur partenaire, le prix, la livraison et les conditions de retour.",
          "Le vendeur partenaire est responsable de l'exécution de la vente, des garanties et du SAV.",
        ],
      },
      {
        title: 'Article 10 à 15 - Responsabilité, données, litiges',
        paragraphs: [
          "Hémo-J n'est pas responsable des manquements du vendeur partenaire, sauf faute propre ou obligation légale impérative.",
          "Les données nécessaires à l'exécution de la commande peuvent être transmises au vendeur partenaire.",
          "Droit applicable : droit français. Contact litiges : contact@hemo-j.com.",
        ],
      },
    ]}
  />
);

export const RgpdPage = () => (
  <LegalPageLayout
    title="RGPD - Politique de Confidentialité"
    sections={[
      {
        title: '1. Responsable du traitement',
        paragraphs: ['Hémo-J, SARL, 60 Rue François 1er 75008 Paris, France.'],
      },
      {
        title: '2. Données collectées',
        paragraphs: [
          "Identité, coordonnées (email/téléphone), adresse de livraison, données de transaction, données de connexion (IP/cookies).",
        ],
      },
      {
        title: '3. Finalités',
        paragraphs: [
          'Gestion des commandes, relation client, newsletter (avec consentement), sécurité et prévention de la fraude.',
        ],
      },
      {
        title: '4. Destinataires',
        paragraphs: [
          "Les données ne sont pas vendues. Elles sont partagées uniquement avec les vendeurs partenaires (pour la livraison), les prestataires techniques et les autorités si nécessaire.",
        ],
      },
      {
        title: '5. Durée de conservation',
        paragraphs: [
          'Compte client : tant que le compte est actif. Documents comptables : 10 ans. Prospection commerciale : 3 ans après le dernier contact.',
        ],
      },
      {
        title: '6. Vos droits',
        paragraphs: [
          "Accès, rectification, effacement, opposition, portabilité. Exercice des droits : contact@hemo-j.com.",
        ],
      },
      {
        title: '7. Sécurité',
        paragraphs: ["Mise en œuvre de mesures techniques et organisationnelles (dont chiffrement SSL) pour protéger vos données."],
      },
    ]}
  />
);

export const ContratReferencementPage = () => (
  <LegalPageLayout
    title="Contrat de Référencement et de Services - Marketplace"
    sections={[
      {
        title: 'Préambule',
        paragraphs: [
          "Contrat entre Hémo-J (E-PRIME DELIVERY, SARL, 60 Rue François 1er 75008 Paris, 999 040 363 R.C.S. Paris) et le vendeur partenaire.",
        ],
      },
      {
        title: 'Article 1 à 3 - Objet, admissibilité produits, engagements vendeur',
        paragraphs: [
          "Le contrat définit les conditions de vente des produits sur la marketplace Hémo-J.",
          "Seuls les produits conformes à la réglementation sont autorisés. Les produits contrefaits, périmés ou interdits sont proscrits.",
          "Le vendeur est responsable de l'exactitude des fiches produits, de la gestion des stocks et de l'expédition.",
        ],
      },
      {
        title: 'Article 4 à 7 - Conditions financières, SAV, données, résiliation',
        paragraphs: [
          "Hémo-J perçoit une commission selon les conditions contractuelles. Les reversements s'effectuent périodiquement après déductions prévues.",
          "Le vendeur assure le SAV et les garanties légales. Les données clients sont utilisées uniquement pour l'exécution des commandes.",
          "Le contrat peut être résilié selon le préavis prévu, avec résiliation immédiate possible en cas de manquement grave.",
        ],
      },
      {
        title: 'Article 8 - Droit applicable',
        paragraphs: ['Le contrat est soumis au droit français. Juridiction compétente : tribunaux de Paris.'],
      },
      {
        title: 'Annexe - Charte qualité et sécurité sanitaire',
        paragraphs: [
          'Conformité réglementaire (marquage CE), traçabilité, communication santé éthique, hygiène de stockage, gestion des rappels produits et engagement éco-responsable.',
        ],
      },
    ]}
  />
);
